import { OptionType } from "@/lib/types";

export const arrayToString = (arr: string[], separator: string): string =>
  arr.join(separator);

export const PROJECT_FILTER_OPTIONS: OptionType[] = [
  { label: "All Projects", value: "" },
  { label: "Single-Page App", value: "single-page-app" },
  { label: "Mobile App", value: "mobile-app" },
  { label: "Websites", value: "websites" },
  { label: "Automotive", value: "automotive" },
  { label: "Web Widget", value: "web-widget" },
  { label: "Web-Based Training", value: "web-based-training" },
  { label: "Trade Show Displays", value: "trade-show-displays" },
  { label: "Desktop App", value: "desktop-app" },
];

export const PRO_SKILLSET_LIST: string[] = [
  "JavaScript",
  "TypeScript",
  "React",
  "Redux",
  "NextJs",
  "TailwindCSS",
  "AntDesign",
  "AngularJs",
  "Html",
  "CSS",
  "GraphQL",
  "Jest",
  "Cypress",
  "DaisyUI",
  "VueJs",
  "Angular",
  "NgRx",
  "Jasmine",
];

export const PRO_TOOLS_LIST: string[] = [
  "VsCode",
  "Storybook",
  "GitHub",
  "Git",
  "NPM",
  "Wordpress",
  "Photoshop",
  "Figma",
];
